// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import NoDataCell from '../NoDataCell';
import { ESGColourDefinition } from '@/enums/Esg';
import ComparisonItem from '@/types/comparison-item';
import DisclaimerInfos from '@/types/disclaimer-infos';
import Locale from '@/types/locale';

type Props = {
  value?: string;
  className?: string;
  item?: ComparisonItem;
  disclaimer?: string;
  onClick?: () => void;
  id?: string;
  valueDisclaimer?: DisclaimerInfos;
  hasDisclaimer?: boolean;
  locale?: Locale;
};

const RatingCell: React.FunctionComponent<Props> = ({ value, className, disclaimer, valueDisclaimer, item, onClick, id, hasDisclaimer, locale }: Props) => {
  if (value == null || value === 'NoValue') {
    return <NoDataCell disclaimerKey={disclaimer} item={item} onClick={onClick} id={id} locale={locale} />;
  }

  let esgRatingColor;

  if (value === 'AA' || value === 'AAA') {
    esgRatingColor = ESGColourDefinition.TEXT_ALIGNED;
  }

  if (value === 'A' || value === 'BBB' || value === 'BB') {
    esgRatingColor = ESGColourDefinition.TEXT_MODERATE;
  }

  if (value === 'B' || value === 'CCC') {
    esgRatingColor = ESGColourDefinition.TEXT_STRONGLY_MISALIGNED;
  }

  return (
    <div className={classNames(className, 'cell esg-rating-cell')} id={id ? `cell-${id}` : undefined} style={{ color: esgRatingColor }} onClick={onClick}>
      <span className="markup-container">{value}</span>
    </div>
  );
};

export default RatingCell;
